import { Controller } from '@hotwired/stimulus'

let deferredInstallPrompt = null

window.addEventListener('beforeinstallprompt', (event) => {
  event.preventDefault()
  deferredInstallPrompt = event
})

export default class extends Controller {
  static targets = [
    'installButton',
    'dialog',
    'iosInstructions',
    'androidInstructions',
    'genericInstructions'
  ]

  connect() {
    this.installed = () => this.hideInstallActions()
    window.addEventListener('appinstalled', this.installed)

    if (this.isStandalone) this.hideInstallActions()
  }

  disconnect() {
    window.removeEventListener('appinstalled', this.installed)
  }

  async install() {
    if (!deferredInstallPrompt) {
      this.openInstructions()
      return
    }

    const prompt = deferredInstallPrompt

    try {
      await prompt.prompt()
      deferredInstallPrompt = null
      const { outcome } = await prompt.userChoice

      if (outcome === 'accepted') this.hideInstallActions()
    } catch (error) {
      console.warn('Não foi possível abrir a instalação nativa do aplicativo.', error)
      this.openInstructions()
    }
  }

  openInstructions() {
    this.iosInstructionsTarget.hidden = !this.isIOS
    this.androidInstructionsTarget.hidden = this.isIOS || !this.isAndroid
    this.genericInstructionsTarget.hidden = this.isIOS || this.isAndroid
    this.dialogTarget.showModal()
  }

  close() {
    this.dialogTarget.close()
  }

  closeFromBackdrop(event) {
    if (event.target === this.dialogTarget) this.close()
  }

  hideInstallActions() {
    deferredInstallPrompt = null
    this.installButtonTargets.forEach((button) => { button.hidden = true })
  }

  get isStandalone() {
    return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true
  }

  get isIOS() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  }

  get isAndroid() {
    return /Android/i.test(navigator.userAgent)
  }
}
